import formData from "@/pages/Cutoff/formData";
export default {
    paper:'',
    gatePapers:formData.gatePapers,
    categories:formData.categories,
    years: formData.years,
}